import React from 'react';
import {
  TableCell,
  TableHead,
  Table,
  TableContainer,
  Paper,
  TableRow,
  TableBody,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import { Link } from 'react-router-dom';

import TablePaginationActions from 'retired/TablePaginationActions';
import getDeedTypeForDisplay from 'utils/getDeedTypeForDisplay';

import { CommunityFull } from './types';

export const DeedsList = ({ deeds }: { deeds: CommunityFull['Deeds'] }): JSX.Element | null => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const deedsCount = deeds.length;

  if (!deedsCount) {
    return null;
  }

  const deedsSliced = deeds.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

  return (
    <TableContainer component={Paper}>
      <h3 style={{ fontWeight: 500, fontSize: 16, marginLeft: 16, marginTop: 20 }}>Tagged Deeds</h3>
      <Table aria-label="list of deeds tagged by the community">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Organized By</TableCell>
            {/* <TableCell>Attendees</TableCell> */}
            <TableCell>Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {deedsSliced.map((deed) => (
            <TableRow key={deed.id}>
              <TableCell component="th" scope="row">
                {deed.name}
              </TableCell>
              <TableCell>
                {deed.OrganizingCommunities.map((c) => (
                  // expects only one community to be displayed
                  <Link to={`/communities/${c.id}`}>{c.title}</Link>
                ))}
              </TableCell>
              {/* <TableCell>
                123
              </TableCell> */}
              <TableCell>{getDeedTypeForDisplay(deed.type)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
        {!!deedsCount && (
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 25, 50, 100]}
                colSpan={3}
                count={deedsCount}
                rowsPerPage={rowsPerPage}
                page={page}
                // @NOTE-AC:
                // Keeping onChangePage (v4) and onPageChange (v5) for now
                // so it does not break when we update the version. And so
                // the type from MUI (that are wrong) stop throwing errors
                onPageChange={(_event, newPage): void => setPage(newPage)}
                onChangePage={(_event, newPage): void => setPage(newPage)}
                onRowsPerPageChange={(event): void => {
                  setRowsPerPage(parseInt(event.target.value, 10));
                  setPage(0);
                }}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        )}
      </Table>
    </TableContainer>
  );
};
